import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { C } from '../shared';
import { money } from './steps';

export const Drivers = ({ option }) => {
  const ex = option?.explanation;
  if (!ex) return null;
  return (
    <div className="rounded-sm border border-[rgba(136,150,168,0.2)] p-3" data-testid="rj-drivers">
      <p className="text-[10px] font-semibold uppercase tracking-wider" style={{ color: C.blue }}>Why this price — top {ex.drivers.length} drivers from the rating trace</p>
      <p className="text-[9px] mb-1" style={{ color: C.slate }}>each driver is a relativity the rater applied; the dollars are what the line would have been at 1.0 · {ex.basis}</p>
      {ex.drivers.length === 0 && <p className="text-[11px]" style={{ color: C.slate }}>every factor rated at 1.0 — the base rates alone set this price</p>}
      {ex.drivers.map((d, i) => (
        <div key={i} className="flex items-center justify-between gap-2 text-[11px] border-t border-[rgba(136,150,168,0.1)] py-1" data-testid={`rj-driver-${d.factor}`}>
          <span className="flex items-center gap-1.5" style={{ color: C.navy }}>
            {d.direction === 'loads' ? <TrendingUp className="w-3 h-3" style={{ color: C.red }} /> : <TrendingDown className="w-3 h-3" style={{ color: C.green }} />}
            <span className="font-mono text-[10px]" style={{ color: C.slate }}>{d.factor}</span> {d.name}{d.level !== null && d.level !== undefined ? ` = ${d.level}` : ''}
            <span className="text-[9px]" style={{ color: C.slate }}>({d.perils.join(', ')})</span>
          </span>
          <span className="font-mono shrink-0" style={{ color: d.direction === 'loads' ? C.red : C.green }}>{d.direction === 'loads' ? '+' : '−'}{money(Math.abs(d.delta_risk_premium))} <span className="text-[9px]" style={{ color: C.slate }}>{d.pct_of_risk_premium}% of risk</span></span>
        </div>
      ))}
      <p className="text-[10px] mt-2" style={{ color: C.slate }} data-testid="rj-peril-shares">perils: {ex.perils.map(p => `${p.peril} ${p.pct_of_risk_premium}%`).join(' · ')}</p>
    </div>
  );
};
